import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#each this.errors as |message|}}\n  <span class=\"validation-error-message\" ...attributes>\n    {{message}}\n  </span>\n{{/each}}\n", {
  moduleName: "ilios-common/components/validation-error.hbs"
});